/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AbstractFinderDialogComponent } from '@gh/common-internal-shared';
import { FormState, FormStateBuilder } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { TranslationService } from '@gh/core-mls';
import { getControlValue } from '@gh/core-ui';
import {
  ScheduleFinderBusinessService,
  ScheduleFinderDialogConfig,
} from '../../resources/schedule-finder-business.service';
import {
  getScheduleFinderListItemId,
  ScheduleFinderListItem,
} from '../../resources/schedule-finder.model';
import { ScheduleFinderGridDefinition } from './schedule-finder-grid-definition.service';

@Component({
  standalone: false,
  selector: 'gh-schedule-finder-dialog',
  templateUrl: 'schedule-finder-dialog.component.html',
  styleUrls: ['schedule-finder-dialog.component.scss'],
  providers: [ScheduleFinderGridDefinition],
})
export class ScheduleFinderDialogComponent
  extends AbstractFinderDialogComponent<ScheduleFinderDialogConfig, ScheduleFinderListItem>
  implements OnInit {

  getId = getScheduleFinderListItemId;

  form: FormState<any>;

  defaultTitle = this.translations.get('lbl_find_schedule');

  constructor(public gridDefinition: ScheduleFinderGridDefinition,
              private translations: TranslationService,
              formStateBuilder: FormStateBuilder,
              private dialogRef: MatDialogRef<any>,
              private businessService: ScheduleFinderBusinessService) {
    super(dialogRef);

    this.form = formStateBuilder.buildPlain({
      children: {
        name: void 0,
      },
    });
  }

  protected buildDataSource(): SlicedDataSource<ScheduleFinderListItem> {
    return this.businessService.findAllAsDataSource(this.input.type, getControlValue(this.form.group, 'name'));
  }
}
